export const isValidGeoJSON = (geoJSONString: string): boolean => {
  try {
    const geoJSONObject = JSON.parse(geoJSONString);

    //   flyToPolygon(statefulMap, geoJSONObject, { duration: 1000 });

    // Additional validation logic can be placed here
    return true;
  } catch (e) {
    return false;
  }
};
